import React from "react";

import Info from "./info";

let routes = [];
routes = routes.concat({ path: "/info", exact: true, name: "basic", component: <Info /> });

export default routes;
